// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Person from "./person.js"
import RoleAbility from "./role-ability.js"
import RoleAbilityGroup from "./role-ability-group.js"
import Tenant from "./tenant.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "identifier": {
      "column": {
        "default": null,
        "name": "identifier",
        "null": false,
        "type": "string"
      },
      "name": "identifier",
      "selected_by_default": null,
      "translated": false
    },
    "initial_reimbursement_tab": {
      "column": {
        "default": null,
        "name": "initial_reimbursement_tab",
        "null": true,
        "type": "string"
      },
      "name": "initial_reimbursement_tab",
      "selected_by_default": null,
      "translated": false
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": null,
      "translated": true
    },
    "navigate_to_admin": {
      "column": {
        "default": false,
        "name": "navigate_to_admin",
        "null": false,
        "type": "boolean"
      },
      "name": "navigate_to_admin",
      "selected_by_default": null,
      "translated": false
    },
    "requires_two_factor_authentication": {
      "column": {
        "default": false,
        "name": "requires_two_factor_authentication",
        "null": false,
        "type": "boolean"
      },
      "name": "requires_two_factor_authentication",
      "selected_by_default": null,
      "translated": false
    }
  },
  "className": "Role",
  "collectionKey": "roles",
  "collectionName": "roles",
  "i18nKey": "role",
  "camelizedLower": "role",
  "name": "Role",
  "nameDasherized": "role",
  "pluralName": "roles",
  "ransackable_associations": [
    {
      "className": "Ability",
      "collectionName": "abilities",
      "foreignKey": "ability_id",
      "name": "abilities",
      "macro": "has_many",
      "resource_name": "Ability",
      "through": "role_abilities"
    },
    {
      "className": "Ability",
      "collectionName": "abilities",
      "foreignKey": "ability_id",
      "name": "abilities_through_groups",
      "macro": "has_many",
      "resource_name": "Ability",
      "through": "role_ability_groups"
    },
    {
      "className": "Role::Translation",
      "collectionName": null,
      "foreignKey": "role_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Person",
      "collectionName": "people",
      "foreignKey": "person_id",
      "name": "people",
      "macro": "has_many",
      "resource_name": "Person",
      "through": "person_roles"
    },
    {
      "className": "PersonRole",
      "collectionName": "person_roles",
      "foreignKey": "role_id",
      "name": "person_roles",
      "macro": "has_many",
      "resource_name": "PersonRole",
      "through": null
    },
    {
      "className": "RoleAbility",
      "collectionName": "role_abilities",
      "foreignKey": "role_id",
      "name": "role_abilities",
      "macro": "has_many",
      "resource_name": "RoleAbility",
      "through": null
    },
    {
      "className": "RoleAbilityGroup",
      "collectionName": "role_ability_groups",
      "foreignKey": "role_id",
      "name": "role_ability_groups",
      "macro": "has_many",
      "resource_name": "RoleAbilityGroup",
      "through": null
    },
    {
      "className": "SubjectRole",
      "collectionName": "subject_roles",
      "foreignKey": "role_id",
      "name": "subject_roles",
      "macro": "has_many",
      "resource_name": "SubjectRole",
      "through": null
    },
    {
      "className": "Subject",
      "collectionName": "subjects",
      "foreignKey": "subject_id",
      "name": "subjects",
      "macro": "has_many",
      "resource_name": "Subject",
      "through": "subject_roles"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "Role::Translation",
      "collectionName": null,
      "foreignKey": "role_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "identifier",
      "column": {
        "default": null,
        "name": "identifier",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "initial_reimbursement_tab",
      "column": {
        "default": null,
        "name": "initial_reimbursement_tab",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "navigate_to_admin",
      "column": {
        "default": false,
        "name": "navigate_to_admin",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "requires_two_factor_authentication",
      "column": {
        "default": false,
        "name": "requires_two_factor_authentication",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Person",
      "collectionName": "people",
      "foreignKey": "person_id",
      "name": "people",
      "macro": "has_many",
      "resource_name": "Person",
      "through": "person_roles"
    },
    {
      "className": "RoleAbility",
      "collectionName": "role_abilities",
      "foreignKey": "role_id",
      "name": "role_abilities",
      "macro": "has_many",
      "resource_name": "RoleAbility",
      "through": null
    },
    {
      "className": "RoleAbilityGroup",
      "collectionName": "role_ability_groups",
      "foreignKey": "role_id",
      "name": "role_ability_groups",
      "macro": "has_many",
      "resource_name": "RoleAbilityGroup",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    }
  ],
  "paramKey": "role",
  "primaryKey": "id"
}

/** Frontend model for Role. */
export default class Role extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  identifier() {
    return this.readAttributeUnderscore("identifier")
  }

  /** @returns {boolean} */
  hasIdentifier() {
    const value = this.identifier()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  initialReimbursementTab() {
    return this.readAttributeUnderscore("initial_reimbursement_tab")
  }

  /** @returns {boolean} */
  hasInitialReimbursementTab() {
    const value = this.initialReimbursementTab()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  navigateToAdmin() {
    return this.readAttributeUnderscore("navigate_to_admin")
  }

  /** @returns {boolean} */
  hasNavigateToAdmin() {
    const value = this.navigateToAdmin()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  requiresTwoFactorAuthentication() {
    return this.readAttributeUnderscore("requires_two_factor_authentication")
  }

  /** @returns {boolean} */
  hasRequiresTwoFactorAuthentication() {
    const value = this.requiresTwoFactorAuthentication()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./person.js").default>} */
  people() {
    return new Collection(
      {
        reflectionName: "people",
        model: this,
        modelClass: Person
      },
      {
        params: {
          through: {
            model: "Role",
            id: this.primaryKey(),
            reflection: "people"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./person.js").default>>} */
  loadPeople() {
    return this._loadHasManyReflection(
      {
        reflectionName: "people",
        model: this,
        modelClass: Person
      },
      {
        params: {
          through: {
            model: "Role",
            id: this.primaryKey(),
            reflection: "people"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./person.js").default>>} */
  ensurePeopleLoaded() {
    return this.ensureAssociationLoaded("people")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./role-ability.js").default>} */
  roleAbilities() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["role_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "role_abilities",
        model: this,
        modelClass: RoleAbility
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./role-ability.js").default>>} */
  loadRoleAbilities() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["role_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "role_abilities",
        model: this,
        modelClass: RoleAbility
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./role-ability.js").default>>} */
  ensureRoleAbilitiesLoaded() {
    return this.ensureAssociationLoaded("role_abilities")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./role-ability-group.js").default>} */
  roleAbilityGroups() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["role_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "role_ability_groups",
        model: this,
        modelClass: RoleAbilityGroup
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./role-ability-group.js").default>>} */
  loadRoleAbilityGroups() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["role_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "role_ability_groups",
        model: this,
        modelClass: RoleAbilityGroup
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./role-ability-group.js").default>>} */
  ensureRoleAbilityGroupsLoaded() {
    return this.ensureAssociationLoaded("role_ability_groups")
  }

  /** @returns {import("./tenant.js").default | null} */
  tenant() {
    return this._readBelongsToReflection({modelClass: Tenant, reflectionName: "tenant"})
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  loadTenant() {
    if (!("tenantId" in this)) throw new Error("Foreign key method wasn't defined: tenantId")

    const id = this.tenantId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant",
        model: this,
        modelClass: Tenant
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  ensureTenantLoaded() {
    return this.ensureAssociationLoaded("tenant")
  }
}
